/**
 * Transliteration table.
 */
const table: {[index: string]: string} = {
	// tslint:disable:object-literal-key-quotes
	'а': 'a',
	'б': 'b',
	'в': 'v',
	'г': 'g',
	'д': 'd',
	'е': 'e',
	'ё': 'yo',
	'ж': 'zh',
	'з': 'z',
	'и': 'i',
	'й': 'y',
	'к': 'k',
	'л': 'l',
	'м': 'm',
	'н': 'n',
	'о': 'o',
	'п': 'p',
	'р': 'r',
	'с': 's',
	'т': 't',
	'у': 'u',
	'ф': 'f',
	'х': 'h',
	'ц': 'ts',
	'ч': 'ch',
	'ш': 'sh',
	'щ': 'sch',
	'ъ': '',
	'ы': 'y',
	'ь': '',
	'э': 'e',
	'ю': 'yu',
	'я': 'ya',
	'А': 'A',
	'Б': 'B',
	'В': 'V',
	'Г': 'G',
	'Д': 'D',
	'Е': 'E',
	'Ё': 'Yo',
	'Ж': 'Zh',
	'З': 'Z',
	'И': 'I',
	'Й': 'Y',
	'К': 'K',
	'Л': 'L',
	'М': 'M',
	'Н': 'N',
	'О': 'O',
	'П': 'P',
	'Р': 'R',
	'С': 'S',
	'Т': 'T',
	'У': 'U',
	'Ф': 'F',
	'Х': 'H',
	'Ц': 'Ts',
	'Ч': 'Ch',
	'Ш': 'Sh',
	'Щ': 'Sch',
	'Ъ': '',
	'Ы': 'Y',
	'Ь': '',
	'Э': 'E',
	'Ю': 'Yu',
	'Я': 'Ya',
};

/**
 * A regular expression using the keys found in the given
 * translitteration object.
 */
const searchPattern = new RegExp(
	`[${Object.keys( table ).join( '' )}]`,
	'g',
);

/**
 * Function used by the resulting replace function.
 * 
 * @param Current char.
 */
function lookupTable( input: string ): string
{
	return (
		( input in table )
		? table[input]
		: input
	);
}

/**
 * Search for occurrences of entries in the translitteration table
 * and replace these with their corresponding values.
 * 
 * @param Subject to transliterate.
 * @returns Transliterated string.
 */
function translit( subject: string ): string
{
	return subject.replace( searchPattern, lookupTable );
}

/**
 * Module
 */
export {
	translit as default,
};



// WEBPACK FOOTER //
// ./app/utils/translit.ts